import React from "react";
import SelectButton from "./search/SelectButton";
class Search extends React.Component {
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex flex-wrap search_box" },
                React.createElement(SelectButton, { uri: `v1/pwj/term/team`, multiple: true }, "\u30C1\u30FC\u30E0"),
                React.createElement(SelectButton, { uri: `v1/pwj/choice/weights`, multiple: true }, "\u5730\u57DF"),
                React.createElement(SelectButton, { uri: `v1/pwj/term/gender`, defaultLabel: "\u3069\u3061\u3089\u3067\u3082" }, "\u6027\u5225"),
                React.createElement(SelectButton, { uri: `v1/pwj/choice/ages`, multiple: true }, "\u5E74\u9F62"),
                React.createElement(SelectButton, { uri: `v1/pwj/term/color`, multiple: true }, "\u6BDB\u8272"),
                React.createElement(SelectButton, { uri: `v1/pwj/term/length`, multiple: true }, "\u907F\u598A\u30FB\u53BB\u52E2"),
                React.createElement("div", { className: "search_btn" },
                    React.createElement("button", { className: "bold", type: "submit" },
                        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 530 500" },
                            React.createElement("path", { d: "M280.3 30C176 30 91.2 114.8 91.2 219.1c0 44.2 15.3 84.7 40.8 117L31.7 436.4 63 467.7l100.3-100.3c32.2 25.5 72.8 40.8 117 40.8 104.3 0 189.1-84.8 189.1-189.1S384.6 30 280.3 30zm0 333.9c-79.8 0-144.8-65-144.8-144.8 0-79.8 64.9-144.8 144.8-144.8s144.8 64.9 144.8 144.8-65 144.8-144.8 144.8z" })),
                        "\u691C\u7D22\u3059\u308B")))));
    }
}
export default Search;
